export type TableColumnWidgetItemProps = {
  tableId: string;
  columnId: string;
  label?: string;
  onClick?: () => void;
};

export const useTableColumnWidgetItem = (props: TableColumnWidgetItemProps) => {
  const { tableId, columnId } = props;

  const settings = localStorage.getItem(tableId);
  const parsedSettings = settings ? JSON.parse(settings) : {};

  const handleClick = () => {
    if (settings) {
      parsedSettings[columnId] = !parsedSettings[columnId];
      localStorage.setItem(tableId, JSON.stringify(parsedSettings));
    } else {
      const newSettings = { [columnId]: true };
      localStorage.setItem(tableId, JSON.stringify(newSettings));
    }
    window.dispatchEvent(new Event('storage'));
  };

  const checked = !!parsedSettings[columnId];

  return { handleClick, checked };
};
